import contextProviders from './ContextProvider';

const ContextComposer = ({ children }) => {
	return contextProviders.reduceRight((composed, Provider) => {
		return <Provider>{composed}</Provider>;
	}, children);
};

export default ContextComposer;
